import React  from "react";
import "./Profile.css";
import { UserProfile } from "../../Features/Profile/index";


const Profile = ({ url }) => {

  return (
    <div className="container">
      <div className="profile-container">
        <div className="profile-page-content-container">
          <div className="profile-page-content">
            {<UserProfile url={url} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
